module.exports = __webpack_public_path__ + "assets/eye-open.26bf09f4.svg";